import React, { FC } from 'react';

interface Props {
    title: string;
}

const SectionTitle: FC<Props> = ({ title }) => {
    return (
        <h2 className="tw-text-[#003865] tw-font-gotham tw-font-bold tw-text-center tw-text-[32px] tw-mb-[30px]">
            {title}
        </h2>
    );
};

export default SectionTitle;
